module.exports = __webpack_public_path__ + "static/img/8.97015e2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/1/zh/8.png
// module id = JLgR
// module chunks = 0